const API_ROOT = 'https://app-node.enterprisetalk.com:3000';
const webPath = 'https://enterprisetalk.com'
// const webPath = 'https://ondot-enterprisetalk.b-cdn.net'
const API_ROOTT = 'https://app-node-enterprisetalk.ondotmail.com:3037';

export {API_ROOTT, API_ROOT,webPath};
